import { Component, OnInit, AfterContentInit } from '@angular/core';
import {  Meta, Title } from '@angular/platform-browser';
import LocomotiveScroll from 'locomotive-scroll';

declare var carousel:any;
declare var scrollNav:any;
declare var splittext01: any;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ritmosDeVida';


  constructor(private titleService: Title, private metaService: Meta) {}

  cookieMessage: 'hola'
  cookieDismiss: 'hola'
  cookieLinkText: 'hola'
  ngOnInit():void {

    
    // setTimeout(() => {
    // new splittext01();
    // scrollNav()
    // }, 250);

    this.metaService.addTags([
      {name: 'description', content: 'Data. Agile Creativity. Business Growth.'},
      {property: 'og:description', content: 'Data. Agile Creativity. Business Growth.'},
      {property: 'og:title', content: 'Maart | Tactic Agency'},
    ]);


    let cc = window as any;
    cc.cookieconsent.initialise({
      palette: {
        popup: {
          background: "#000"
        },
        button: {
          background: "#fff",
          text: "#000"
        }
      },
      theme: "classic",
      content: {
        message: 'Esta web utiliza cookies para asegurar la mejor experiencia del usuario en la página.',
        dismiss: 'Cerrar',
        link: 'Saber más',
        href: "/cookies",
        target: '',
      }
      


    });
    







    }


}




